/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RoiCalculatorRouteImport } from './routes/roi-calculator'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CredentialResetRequestRouteImport } from './routes/credential-reset-request'
import { Route as CredentialResetRouteImport } from './routes/credential-reset'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as SyncIndexRouteImport } from './routes/sync/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as InstallFlowSensorScanRouteImport } from './routes/installFlow/sensor-scan'
import { Route as InstallFlowSensorInstalledRouteImport } from './routes/installFlow/sensor-installed'
import { Route as InstallFlowSelectOrganizationRouteImport } from './routes/installFlow/select-organization'
import { Route as InstallFlowReviewNamePlatePhotoRouteImport } from './routes/installFlow/review-name-plate-photo'
import { Route as InstallFlowReviewNamePlateInfoRouteImport } from './routes/installFlow/review-name-plate-info'
import { Route as InstallFlowPreviousTutorialRouteImport } from './routes/installFlow/previous-tutorial'
import { Route as InstallFlowPhysicalInstallStepsRouteImport } from './routes/installFlow/physical-install-steps'
import { Route as InstallFlowOnSiteLocationRouteImport } from './routes/installFlow/on-site-location'
import { Route as InstallFlowNamePlatePhotoRouteImport } from './routes/installFlow/name-plate-photo'
import { Route as InstallFlowMatchExistingAssetRouteImport } from './routes/installFlow/match-existing-asset'
import { Route as InstallFlowLiveDataRouteImport } from './routes/installFlow/live-data'
import { Route as InstallFlowInstallNotStartedRouteImport } from './routes/installFlow/install-not-started'
import { Route as InstallFlowForgotPasswordRouteImport } from './routes/installFlow/forgot-password'
import { Route as InstallFlowFinalCheckRouteImport } from './routes/installFlow/final-check'
import { Route as InstallFlowEnterNamePlateInfoRouteImport } from './routes/installFlow/enter-name-plate-info'
import { Route as InstallFlowCreateAssetLocationRouteImport } from './routes/installFlow/create-asset-location'
import { Route as InstallFlowCompletePhysicalInstallRouteImport } from './routes/installFlow/complete-physical-install'
import { Route as InstallFlowAuthInstallFlowRouteImport } from './routes/installFlow/auth-install-flow'
import { Route as InstallFlowAssetNameRouteImport } from './routes/installFlow/asset-name'
import { Route as InstallFlowAssetLocationRouteImport } from './routes/installFlow/asset-location'
import { Route as InstallFlowAprovedInstallFlowRouteImport } from './routes/installFlow/aproved-install-flow'
import { Route as InstallFlowAlreadyInstalledRouteImport } from './routes/installFlow/already-installed'
import { Route as InstallFlowAddNewLocationRouteImport } from './routes/installFlow/add-new-location'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedComing_soonRouteImport } from './routes/_authenticated/coming_soon'
import { Route as AuthenticatedStaffRouteRouteImport } from './routes/_authenticated/_staff/route'
import { Route as SyncSensorKitSerialNumberIndexRouteImport } from './routes/sync/$sensorKitSerialNumber/index'
import { Route as AuthenticatedOrganizationIndexRouteImport } from './routes/_authenticated/organization/index'
import { Route as SyncSensorKitSerialNumberValidateRouteImport } from './routes/sync/$sensorKitSerialNumber/validate'
import { Route as OpportunitiesSharedTokenRouteImport } from './routes/opportunities/shared/$token'
import { Route as IssuesSharedTokenRouteImport } from './routes/issues/shared/$token'
import { Route as AuthVerifyEmailKeyRouteImport } from './routes/auth.verify-email.$key'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedOrganizationNoOrganizationsRouteImport } from './routes/_authenticated/organization/no-organizations'
import { Route as AuthenticatedStaffValidateSensorPlacementRouteImport } from './routes/_authenticated/_staff/validate-sensor-placement'
import { Route as AuthenticatedStaffSensorKitHealthNewRouteImport } from './routes/_authenticated/_staff/sensor-kit-health-new'
import { Route as AuthenticatedStaffSensorKitHealthRouteImport } from './routes/_authenticated/_staff/sensor-kit-health'
import { Route as AuthenticatedStaffOpportunityManagementRouteImport } from './routes/_authenticated/_staff/opportunity-management'
import { Route as AuthenticatedStaffIssueManagementRouteImport } from './routes/_authenticated/_staff/issue-management'
import { Route as AuthenticatedStaffEmailConciergeRouteImport } from './routes/_authenticated/_staff/email-concierge'
import { Route as AuthenticatedStaffAllOrganizationsRouteImport } from './routes/_authenticated/_staff/all-organizations'
import { Route as AuthenticatedOrganizationOrganizationIdRouteRouteImport } from './routes/_authenticated/organization/$organizationId/route'
import { Route as AuthenticatedStaffWith_location_switcherRouteRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/route'
import { Route as AuthenticatedOrganizationOrganizationIdInstallFlowRouteImport } from './routes/_authenticated/organization/$organizationId/install-flow'
import { Route as AuthenticatedStaffAchievementsLeaderboardRouteImport } from './routes/_authenticated/_staff/achievements/leaderboard'
import { Route as AuthenticatedStaffAchievementsUserIdRouteImport } from './routes/_authenticated/_staff/achievements/$userId'
import { Route as AuthenticatedStaffWith_location_switcherTrendsBetaRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/trends-beta'
import { Route as AuthenticatedStaffWith_location_switcherMetricsRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/metrics'
import { Route as AuthenticatedStaffWith_location_switcherEngineeringChartsRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/engineering-charts'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/route'
import { Route as AuthenticatedOrganizationOrganizationIdInstallerRouteRouteImport } from './routes/_authenticated/organization/$organizationId/_installer/route'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/index'
import { Route as AuthenticatedStaffWith_location_switcherMetersIndexRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/meters/index'
import { Route as AuthenticatedOrganizationOrganizationIdInstallerInstallRouteImport } from './routes/_authenticated/organization/$organizationId/_installer/install'
import { Route as AuthenticatedStaffWith_location_switcherMetersMeterIdRouteImport } from './routes/_authenticated/_staff/_with_location_switcher/meters/$meterId'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/opportunities/route'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/issues/route'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/users/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/opportunities/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/issues/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/invite-codes/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/route'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/index'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health'
import { Route as AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRouteImport } from './routes/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/charge-detection'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const RoiCalculatorRoute = RoiCalculatorRouteImport.update({
  id: '/roi-calculator',
  path: '/roi-calculator',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CredentialResetRequestRoute = CredentialResetRequestRouteImport.update({
  id: '/credential-reset-request',
  path: '/credential-reset-request',
  getParentRoute: () => rootRouteImport,
} as any)
const CredentialResetRoute = CredentialResetRouteImport.update({
  id: '/credential-reset',
  path: '/credential-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SyncIndexRoute = SyncIndexRouteImport.update({
  id: '/sync/',
  path: '/sync/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const InstallFlowSensorScanRoute = InstallFlowSensorScanRouteImport.update({
  id: '/installFlow/sensor-scan',
  path: '/installFlow/sensor-scan',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallFlowSensorInstalledRoute =
  InstallFlowSensorInstalledRouteImport.update({
    id: '/installFlow/sensor-installed',
    path: '/installFlow/sensor-installed',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowSelectOrganizationRoute =
  InstallFlowSelectOrganizationRouteImport.update({
    id: '/installFlow/select-organization',
    path: '/installFlow/select-organization',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowReviewNamePlatePhotoRoute =
  InstallFlowReviewNamePlatePhotoRouteImport.update({
    id: '/installFlow/review-name-plate-photo',
    path: '/installFlow/review-name-plate-photo',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowReviewNamePlateInfoRoute =
  InstallFlowReviewNamePlateInfoRouteImport.update({
    id: '/installFlow/review-name-plate-info',
    path: '/installFlow/review-name-plate-info',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowPreviousTutorialRoute =
  InstallFlowPreviousTutorialRouteImport.update({
    id: '/installFlow/previous-tutorial',
    path: '/installFlow/previous-tutorial',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowPhysicalInstallStepsRoute =
  InstallFlowPhysicalInstallStepsRouteImport.update({
    id: '/installFlow/physical-install-steps',
    path: '/installFlow/physical-install-steps',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowOnSiteLocationRoute =
  InstallFlowOnSiteLocationRouteImport.update({
    id: '/installFlow/on-site-location',
    path: '/installFlow/on-site-location',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowNamePlatePhotoRoute =
  InstallFlowNamePlatePhotoRouteImport.update({
    id: '/installFlow/name-plate-photo',
    path: '/installFlow/name-plate-photo',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowMatchExistingAssetRoute =
  InstallFlowMatchExistingAssetRouteImport.update({
    id: '/installFlow/match-existing-asset',
    path: '/installFlow/match-existing-asset',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowLiveDataRoute = InstallFlowLiveDataRouteImport.update({
  id: '/installFlow/live-data',
  path: '/installFlow/live-data',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallFlowInstallNotStartedRoute =
  InstallFlowInstallNotStartedRouteImport.update({
    id: '/installFlow/install-not-started',
    path: '/installFlow/install-not-started',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowForgotPasswordRoute =
  InstallFlowForgotPasswordRouteImport.update({
    id: '/installFlow/forgot-password',
    path: '/installFlow/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowFinalCheckRoute = InstallFlowFinalCheckRouteImport.update({
  id: '/installFlow/final-check',
  path: '/installFlow/final-check',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallFlowEnterNamePlateInfoRoute =
  InstallFlowEnterNamePlateInfoRouteImport.update({
    id: '/installFlow/enter-name-plate-info',
    path: '/installFlow/enter-name-plate-info',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowCreateAssetLocationRoute =
  InstallFlowCreateAssetLocationRouteImport.update({
    id: '/installFlow/create-asset-location',
    path: '/installFlow/create-asset-location',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowCompletePhysicalInstallRoute =
  InstallFlowCompletePhysicalInstallRouteImport.update({
    id: '/installFlow/complete-physical-install',
    path: '/installFlow/complete-physical-install',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowAuthInstallFlowRoute =
  InstallFlowAuthInstallFlowRouteImport.update({
    id: '/installFlow/auth-install-flow',
    path: '/installFlow/auth-install-flow',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowAssetNameRoute = InstallFlowAssetNameRouteImport.update({
  id: '/installFlow/asset-name',
  path: '/installFlow/asset-name',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallFlowAssetLocationRoute =
  InstallFlowAssetLocationRouteImport.update({
    id: '/installFlow/asset-location',
    path: '/installFlow/asset-location',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowAprovedInstallFlowRoute =
  InstallFlowAprovedInstallFlowRouteImport.update({
    id: '/installFlow/aproved-install-flow',
    path: '/installFlow/aproved-install-flow',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowAlreadyInstalledRoute =
  InstallFlowAlreadyInstalledRouteImport.update({
    id: '/installFlow/already-installed',
    path: '/installFlow/already-installed',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstallFlowAddNewLocationRoute =
  InstallFlowAddNewLocationRouteImport.update({
    id: '/installFlow/add-new-location',
    path: '/installFlow/add-new-location',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedComing_soonRoute =
  AuthenticatedComing_soonRouteImport.update({
    id: '/coming_soon',
    path: '/coming_soon',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffRouteRoute = AuthenticatedStaffRouteRouteImport.update({
  id: '/_staff',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const SyncSensorKitSerialNumberIndexRoute =
  SyncSensorKitSerialNumberIndexRouteImport.update({
    id: '/sync/$sensorKitSerialNumber/',
    path: '/sync/$sensorKitSerialNumber/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedOrganizationIndexRoute =
  AuthenticatedOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const SyncSensorKitSerialNumberValidateRoute =
  SyncSensorKitSerialNumberValidateRouteImport.update({
    id: '/sync/$sensorKitSerialNumber/validate',
    path: '/sync/$sensorKitSerialNumber/validate',
    getParentRoute: () => rootRouteImport,
  } as any)
const OpportunitiesSharedTokenRoute =
  OpportunitiesSharedTokenRouteImport.update({
    id: '/opportunities/shared/$token',
    path: '/opportunities/shared/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const IssuesSharedTokenRoute = IssuesSharedTokenRouteImport.update({
  id: '/issues/shared/$token',
  path: '/issues/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailKeyRoute = AuthVerifyEmailKeyRouteImport.update({
  id: '/auth/verify-email/$key',
  path: '/auth/verify-email/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationNoOrganizationsRoute =
  AuthenticatedOrganizationNoOrganizationsRouteImport.update({
    id: '/organization/no-organizations',
    path: '/organization/no-organizations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffValidateSensorPlacementRoute =
  AuthenticatedStaffValidateSensorPlacementRouteImport.update({
    id: '/validate-sensor-placement',
    path: '/validate-sensor-placement',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffSensorKitHealthNewRoute =
  AuthenticatedStaffSensorKitHealthNewRouteImport.update({
    id: '/sensor-kit-health-new',
    path: '/sensor-kit-health-new',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffSensorKitHealthRoute =
  AuthenticatedStaffSensorKitHealthRouteImport.update({
    id: '/sensor-kit-health',
    path: '/sensor-kit-health',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffOpportunityManagementRoute =
  AuthenticatedStaffOpportunityManagementRouteImport.update({
    id: '/opportunity-management',
    path: '/opportunity-management',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffIssueManagementRoute =
  AuthenticatedStaffIssueManagementRouteImport.update({
    id: '/issue-management',
    path: '/issue-management',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffEmailConciergeRoute =
  AuthenticatedStaffEmailConciergeRouteImport.update({
    id: '/email-concierge',
    path: '/email-concierge',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffAllOrganizationsRoute =
  AuthenticatedStaffAllOrganizationsRouteImport.update({
    id: '/all-organizations',
    path: '/all-organizations',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdRouteRoute =
  AuthenticatedOrganizationOrganizationIdRouteRouteImport.update({
    id: '/organization/$organizationId',
    path: '/organization/$organizationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherRouteRoute =
  AuthenticatedStaffWith_location_switcherRouteRouteImport.update({
    id: '/_with_location_switcher',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdInstallFlowRoute =
  AuthenticatedOrganizationOrganizationIdInstallFlowRouteImport.update({
    id: '/install-flow',
    path: '/install-flow',
    getParentRoute: () => AuthenticatedOrganizationOrganizationIdRouteRoute,
  } as any)
const AuthenticatedStaffAchievementsLeaderboardRoute =
  AuthenticatedStaffAchievementsLeaderboardRouteImport.update({
    id: '/achievements/leaderboard',
    path: '/achievements/leaderboard',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffAchievementsUserIdRoute =
  AuthenticatedStaffAchievementsUserIdRouteImport.update({
    id: '/achievements/$userId',
    path: '/achievements/$userId',
    getParentRoute: () => AuthenticatedStaffRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherTrendsBetaRoute =
  AuthenticatedStaffWith_location_switcherTrendsBetaRouteImport.update({
    id: '/trends-beta',
    path: '/trends-beta',
    getParentRoute: () => AuthenticatedStaffWith_location_switcherRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherMetricsRoute =
  AuthenticatedStaffWith_location_switcherMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AuthenticatedStaffWith_location_switcherRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherEngineeringChartsRoute =
  AuthenticatedStaffWith_location_switcherEngineeringChartsRouteImport.update({
    id: '/engineering-charts',
    path: '/engineering-charts',
    getParentRoute: () => AuthenticatedStaffWith_location_switcherRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteImport.update({
    id: '/_non_installer',
    getParentRoute: () => AuthenticatedOrganizationOrganizationIdRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdInstallerRouteRoute =
  AuthenticatedOrganizationOrganizationIdInstallerRouteRouteImport.update({
    id: '/_installer',
    getParentRoute: () => AuthenticatedOrganizationOrganizationIdRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherMetersIndexRoute =
  AuthenticatedStaffWith_location_switcherMetersIndexRouteImport.update({
    id: '/meters/',
    path: '/meters/',
    getParentRoute: () => AuthenticatedStaffWith_location_switcherRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdInstallerInstallRoute =
  AuthenticatedOrganizationOrganizationIdInstallerInstallRouteImport.update({
    id: '/install',
    path: '/install',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationIdInstallerRouteRoute,
  } as any)
const AuthenticatedStaffWith_location_switcherMetersMeterIdRoute =
  AuthenticatedStaffWith_location_switcherMetersMeterIdRouteImport.update({
    id: '/meters/$meterId',
    path: '/meters/$meterId',
    getParentRoute: () => AuthenticatedStaffWith_location_switcherRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteImport.update(
    {
      id: '/opportunities',
      path: '/opportunities',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteImport.update(
    {
      id: '/issues',
      path: '/issues',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRouteImport.update(
    {
      id: '/users/',
      path: '/users/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRouteImport.update(
    {
      id: '/locations/',
      path: '/locations/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRouteImport.update(
    {
      id: '/invite-codes/',
      path: '/invite-codes/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRouteImport.update(
    {
      id: '/$opportunityId',
      path: '/$opportunityId',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRouteImport.update(
    {
      id: '/$opportunityId',
      path: '/$opportunityId',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteImport.update(
    {
      id: '/locations/$locationId',
      path: '/locations/$locationId',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRouteImport.update(
    {
      id: '/equipment/$equipmentId/',
      path: '/equipment/$equipmentId/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRouteImport.update(
    {
      id: '/assets/$assetId/',
      path: '/assets/$assetId/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRouteImport.update(
    {
      id: '/assets/$assetId/on_period_analysis',
      path: '/assets/$assetId/on_period_analysis',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRouteImport.update(
    {
      id: '/assets/$assetId/health',
      path: '/assets/$assetId/health',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRouteImport.update(
    {
      id: '/assets/$assetId/charge-detection',
      path: '/assets/$assetId/charge-detection',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/credential-reset': typeof CredentialResetRoute
  '/credential-reset-request': typeof CredentialResetRequestRoute
  '/login': typeof LoginRoute
  '/roi-calculator': typeof RoiCalculatorRoute
  '/signup': typeof SignupRoute
  '/coming_soon': typeof AuthenticatedComing_soonRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/installFlow/add-new-location': typeof InstallFlowAddNewLocationRoute
  '/installFlow/already-installed': typeof InstallFlowAlreadyInstalledRoute
  '/installFlow/aproved-install-flow': typeof InstallFlowAprovedInstallFlowRoute
  '/installFlow/asset-location': typeof InstallFlowAssetLocationRoute
  '/installFlow/asset-name': typeof InstallFlowAssetNameRoute
  '/installFlow/auth-install-flow': typeof InstallFlowAuthInstallFlowRoute
  '/installFlow/complete-physical-install': typeof InstallFlowCompletePhysicalInstallRoute
  '/installFlow/create-asset-location': typeof InstallFlowCreateAssetLocationRoute
  '/installFlow/enter-name-plate-info': typeof InstallFlowEnterNamePlateInfoRoute
  '/installFlow/final-check': typeof InstallFlowFinalCheckRoute
  '/installFlow/forgot-password': typeof InstallFlowForgotPasswordRoute
  '/installFlow/install-not-started': typeof InstallFlowInstallNotStartedRoute
  '/installFlow/live-data': typeof InstallFlowLiveDataRoute
  '/installFlow/match-existing-asset': typeof InstallFlowMatchExistingAssetRoute
  '/installFlow/name-plate-photo': typeof InstallFlowNamePlatePhotoRoute
  '/installFlow/on-site-location': typeof InstallFlowOnSiteLocationRoute
  '/installFlow/physical-install-steps': typeof InstallFlowPhysicalInstallStepsRoute
  '/installFlow/previous-tutorial': typeof InstallFlowPreviousTutorialRoute
  '/installFlow/review-name-plate-info': typeof InstallFlowReviewNamePlateInfoRoute
  '/installFlow/review-name-plate-photo': typeof InstallFlowReviewNamePlatePhotoRoute
  '/installFlow/select-organization': typeof InstallFlowSelectOrganizationRoute
  '/installFlow/sensor-installed': typeof InstallFlowSensorInstalledRoute
  '/installFlow/sensor-scan': typeof InstallFlowSensorScanRoute
  '/': typeof AuthenticatedIndexRoute
  '/sync': typeof SyncIndexRoute
  '/organization/$organizationId': typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteWithChildren
  '/all-organizations': typeof AuthenticatedStaffAllOrganizationsRoute
  '/email-concierge': typeof AuthenticatedStaffEmailConciergeRoute
  '/issue-management': typeof AuthenticatedStaffIssueManagementRoute
  '/opportunity-management': typeof AuthenticatedStaffOpportunityManagementRoute
  '/sensor-kit-health': typeof AuthenticatedStaffSensorKitHealthRoute
  '/sensor-kit-health-new': typeof AuthenticatedStaffSensorKitHealthNewRoute
  '/validate-sensor-placement': typeof AuthenticatedStaffValidateSensorPlacementRoute
  '/organization/no-organizations': typeof AuthenticatedOrganizationNoOrganizationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/auth/verify-email/$key': typeof AuthVerifyEmailKeyRoute
  '/issues/shared/$token': typeof IssuesSharedTokenRoute
  '/opportunities/shared/$token': typeof OpportunitiesSharedTokenRoute
  '/sync/$sensorKitSerialNumber/validate': typeof SyncSensorKitSerialNumberValidateRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/sync/$sensorKitSerialNumber': typeof SyncSensorKitSerialNumberIndexRoute
  '/engineering-charts': typeof AuthenticatedStaffWith_location_switcherEngineeringChartsRoute
  '/metrics': typeof AuthenticatedStaffWith_location_switcherMetricsRoute
  '/trends-beta': typeof AuthenticatedStaffWith_location_switcherTrendsBetaRoute
  '/achievements/$userId': typeof AuthenticatedStaffAchievementsUserIdRoute
  '/achievements/leaderboard': typeof AuthenticatedStaffAchievementsLeaderboardRoute
  '/organization/$organizationId/install-flow': typeof AuthenticatedOrganizationOrganizationIdInstallFlowRoute
  '/organization/$organizationId/issues': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteWithChildren
  '/organization/$organizationId/opportunities': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteWithChildren
  '/meters/$meterId': typeof AuthenticatedStaffWith_location_switcherMetersMeterIdRoute
  '/organization/$organizationId/install': typeof AuthenticatedOrganizationOrganizationIdInstallerInstallRoute
  '/meters': typeof AuthenticatedStaffWith_location_switcherMetersIndexRoute
  '/organization/$organizationId/': typeof AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute
  '/organization/$organizationId/locations/$locationId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteWithChildren
  '/organization/$organizationId/issues/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute
  '/organization/$organizationId/opportunities/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute
  '/organization/$organizationId/invite-codes': typeof AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute
  '/organization/$organizationId/issues/': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute
  '/organization/$organizationId/locations': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute
  '/organization/$organizationId/opportunities/': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute
  '/organization/$organizationId/users': typeof AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute
  '/organization/$organizationId/locations/$locationId/': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/charge-detection': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/health': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/on_period_analysis': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute
  '/organization/$organizationId/locations/$locationId/equipment/$equipmentId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute
}
export interface FileRoutesByTo {
  '/credential-reset': typeof CredentialResetRoute
  '/credential-reset-request': typeof CredentialResetRequestRoute
  '/login': typeof LoginRoute
  '/roi-calculator': typeof RoiCalculatorRoute
  '/signup': typeof SignupRoute
  '/coming_soon': typeof AuthenticatedComing_soonRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/installFlow/add-new-location': typeof InstallFlowAddNewLocationRoute
  '/installFlow/already-installed': typeof InstallFlowAlreadyInstalledRoute
  '/installFlow/aproved-install-flow': typeof InstallFlowAprovedInstallFlowRoute
  '/installFlow/asset-location': typeof InstallFlowAssetLocationRoute
  '/installFlow/asset-name': typeof InstallFlowAssetNameRoute
  '/installFlow/auth-install-flow': typeof InstallFlowAuthInstallFlowRoute
  '/installFlow/complete-physical-install': typeof InstallFlowCompletePhysicalInstallRoute
  '/installFlow/create-asset-location': typeof InstallFlowCreateAssetLocationRoute
  '/installFlow/enter-name-plate-info': typeof InstallFlowEnterNamePlateInfoRoute
  '/installFlow/final-check': typeof InstallFlowFinalCheckRoute
  '/installFlow/forgot-password': typeof InstallFlowForgotPasswordRoute
  '/installFlow/install-not-started': typeof InstallFlowInstallNotStartedRoute
  '/installFlow/live-data': typeof InstallFlowLiveDataRoute
  '/installFlow/match-existing-asset': typeof InstallFlowMatchExistingAssetRoute
  '/installFlow/name-plate-photo': typeof InstallFlowNamePlatePhotoRoute
  '/installFlow/on-site-location': typeof InstallFlowOnSiteLocationRoute
  '/installFlow/physical-install-steps': typeof InstallFlowPhysicalInstallStepsRoute
  '/installFlow/previous-tutorial': typeof InstallFlowPreviousTutorialRoute
  '/installFlow/review-name-plate-info': typeof InstallFlowReviewNamePlateInfoRoute
  '/installFlow/review-name-plate-photo': typeof InstallFlowReviewNamePlatePhotoRoute
  '/installFlow/select-organization': typeof InstallFlowSelectOrganizationRoute
  '/installFlow/sensor-installed': typeof InstallFlowSensorInstalledRoute
  '/installFlow/sensor-scan': typeof InstallFlowSensorScanRoute
  '/': typeof AuthenticatedIndexRoute
  '/sync': typeof SyncIndexRoute
  '/organization/$organizationId': typeof AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute
  '/all-organizations': typeof AuthenticatedStaffAllOrganizationsRoute
  '/email-concierge': typeof AuthenticatedStaffEmailConciergeRoute
  '/issue-management': typeof AuthenticatedStaffIssueManagementRoute
  '/opportunity-management': typeof AuthenticatedStaffOpportunityManagementRoute
  '/sensor-kit-health': typeof AuthenticatedStaffSensorKitHealthRoute
  '/sensor-kit-health-new': typeof AuthenticatedStaffSensorKitHealthNewRoute
  '/validate-sensor-placement': typeof AuthenticatedStaffValidateSensorPlacementRoute
  '/organization/no-organizations': typeof AuthenticatedOrganizationNoOrganizationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/auth/verify-email/$key': typeof AuthVerifyEmailKeyRoute
  '/issues/shared/$token': typeof IssuesSharedTokenRoute
  '/opportunities/shared/$token': typeof OpportunitiesSharedTokenRoute
  '/sync/$sensorKitSerialNumber/validate': typeof SyncSensorKitSerialNumberValidateRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/sync/$sensorKitSerialNumber': typeof SyncSensorKitSerialNumberIndexRoute
  '/engineering-charts': typeof AuthenticatedStaffWith_location_switcherEngineeringChartsRoute
  '/metrics': typeof AuthenticatedStaffWith_location_switcherMetricsRoute
  '/trends-beta': typeof AuthenticatedStaffWith_location_switcherTrendsBetaRoute
  '/achievements/$userId': typeof AuthenticatedStaffAchievementsUserIdRoute
  '/achievements/leaderboard': typeof AuthenticatedStaffAchievementsLeaderboardRoute
  '/organization/$organizationId/install-flow': typeof AuthenticatedOrganizationOrganizationIdInstallFlowRoute
  '/meters/$meterId': typeof AuthenticatedStaffWith_location_switcherMetersMeterIdRoute
  '/organization/$organizationId/install': typeof AuthenticatedOrganizationOrganizationIdInstallerInstallRoute
  '/meters': typeof AuthenticatedStaffWith_location_switcherMetersIndexRoute
  '/organization/$organizationId/issues/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute
  '/organization/$organizationId/opportunities/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute
  '/organization/$organizationId/invite-codes': typeof AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute
  '/organization/$organizationId/issues': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute
  '/organization/$organizationId/locations': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute
  '/organization/$organizationId/opportunities': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute
  '/organization/$organizationId/users': typeof AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute
  '/organization/$organizationId/locations/$locationId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/charge-detection': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/health': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId/on_period_analysis': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute
  '/organization/$organizationId/locations/$locationId/assets/$assetId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute
  '/organization/$organizationId/locations/$locationId/equipment/$equipmentId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/credential-reset': typeof CredentialResetRoute
  '/credential-reset-request': typeof CredentialResetRequestRoute
  '/login': typeof LoginRoute
  '/roi-calculator': typeof RoiCalculatorRoute
  '/signup': typeof SignupRoute
  '/_authenticated/_staff': typeof AuthenticatedStaffRouteRouteWithChildren
  '/_authenticated/coming_soon': typeof AuthenticatedComing_soonRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/installFlow/add-new-location': typeof InstallFlowAddNewLocationRoute
  '/installFlow/already-installed': typeof InstallFlowAlreadyInstalledRoute
  '/installFlow/aproved-install-flow': typeof InstallFlowAprovedInstallFlowRoute
  '/installFlow/asset-location': typeof InstallFlowAssetLocationRoute
  '/installFlow/asset-name': typeof InstallFlowAssetNameRoute
  '/installFlow/auth-install-flow': typeof InstallFlowAuthInstallFlowRoute
  '/installFlow/complete-physical-install': typeof InstallFlowCompletePhysicalInstallRoute
  '/installFlow/create-asset-location': typeof InstallFlowCreateAssetLocationRoute
  '/installFlow/enter-name-plate-info': typeof InstallFlowEnterNamePlateInfoRoute
  '/installFlow/final-check': typeof InstallFlowFinalCheckRoute
  '/installFlow/forgot-password': typeof InstallFlowForgotPasswordRoute
  '/installFlow/install-not-started': typeof InstallFlowInstallNotStartedRoute
  '/installFlow/live-data': typeof InstallFlowLiveDataRoute
  '/installFlow/match-existing-asset': typeof InstallFlowMatchExistingAssetRoute
  '/installFlow/name-plate-photo': typeof InstallFlowNamePlatePhotoRoute
  '/installFlow/on-site-location': typeof InstallFlowOnSiteLocationRoute
  '/installFlow/physical-install-steps': typeof InstallFlowPhysicalInstallStepsRoute
  '/installFlow/previous-tutorial': typeof InstallFlowPreviousTutorialRoute
  '/installFlow/review-name-plate-info': typeof InstallFlowReviewNamePlateInfoRoute
  '/installFlow/review-name-plate-photo': typeof InstallFlowReviewNamePlatePhotoRoute
  '/installFlow/select-organization': typeof InstallFlowSelectOrganizationRoute
  '/installFlow/sensor-installed': typeof InstallFlowSensorInstalledRoute
  '/installFlow/sensor-scan': typeof InstallFlowSensorScanRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/sync/': typeof SyncIndexRoute
  '/_authenticated/_staff/_with_location_switcher': typeof AuthenticatedStaffWith_location_switcherRouteRouteWithChildren
  '/_authenticated/organization/$organizationId': typeof AuthenticatedOrganizationOrganizationIdRouteRouteWithChildren
  '/_authenticated/_staff/all-organizations': typeof AuthenticatedStaffAllOrganizationsRoute
  '/_authenticated/_staff/email-concierge': typeof AuthenticatedStaffEmailConciergeRoute
  '/_authenticated/_staff/issue-management': typeof AuthenticatedStaffIssueManagementRoute
  '/_authenticated/_staff/opportunity-management': typeof AuthenticatedStaffOpportunityManagementRoute
  '/_authenticated/_staff/sensor-kit-health': typeof AuthenticatedStaffSensorKitHealthRoute
  '/_authenticated/_staff/sensor-kit-health-new': typeof AuthenticatedStaffSensorKitHealthNewRoute
  '/_authenticated/_staff/validate-sensor-placement': typeof AuthenticatedStaffValidateSensorPlacementRoute
  '/_authenticated/organization/no-organizations': typeof AuthenticatedOrganizationNoOrganizationsRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/auth/verify-email/$key': typeof AuthVerifyEmailKeyRoute
  '/issues/shared/$token': typeof IssuesSharedTokenRoute
  '/opportunities/shared/$token': typeof OpportunitiesSharedTokenRoute
  '/sync/$sensorKitSerialNumber/validate': typeof SyncSensorKitSerialNumberValidateRoute
  '/_authenticated/organization/': typeof AuthenticatedOrganizationIndexRoute
  '/sync/$sensorKitSerialNumber/': typeof SyncSensorKitSerialNumberIndexRoute
  '/_authenticated/organization/$organizationId/_installer': typeof AuthenticatedOrganizationOrganizationIdInstallerRouteRouteWithChildren
  '/_authenticated/organization/$organizationId/_non_installer': typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteWithChildren
  '/_authenticated/_staff/_with_location_switcher/engineering-charts': typeof AuthenticatedStaffWith_location_switcherEngineeringChartsRoute
  '/_authenticated/_staff/_with_location_switcher/metrics': typeof AuthenticatedStaffWith_location_switcherMetricsRoute
  '/_authenticated/_staff/_with_location_switcher/trends-beta': typeof AuthenticatedStaffWith_location_switcherTrendsBetaRoute
  '/_authenticated/_staff/achievements/$userId': typeof AuthenticatedStaffAchievementsUserIdRoute
  '/_authenticated/_staff/achievements/leaderboard': typeof AuthenticatedStaffAchievementsLeaderboardRoute
  '/_authenticated/organization/$organizationId/install-flow': typeof AuthenticatedOrganizationOrganizationIdInstallFlowRoute
  '/_authenticated/organization/$organizationId/_non_installer/issues': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteWithChildren
  '/_authenticated/organization/$organizationId/_non_installer/opportunities': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteWithChildren
  '/_authenticated/_staff/_with_location_switcher/meters/$meterId': typeof AuthenticatedStaffWith_location_switcherMetersMeterIdRoute
  '/_authenticated/organization/$organizationId/_installer/install': typeof AuthenticatedOrganizationOrganizationIdInstallerInstallRoute
  '/_authenticated/_staff/_with_location_switcher/meters/': typeof AuthenticatedStaffWith_location_switcherMetersIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/': typeof AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteWithChildren
  '/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute
  '/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute
  '/_authenticated/organization/$organizationId/_non_installer/invite-codes/': typeof AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/issues/': typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/opportunities/': typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/users/': typeof AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/charge-detection': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/': typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/credential-reset'
    | '/credential-reset-request'
    | '/login'
    | '/roi-calculator'
    | '/signup'
    | '/coming_soon'
    | '/auth/callback'
    | '/installFlow/add-new-location'
    | '/installFlow/already-installed'
    | '/installFlow/aproved-install-flow'
    | '/installFlow/asset-location'
    | '/installFlow/asset-name'
    | '/installFlow/auth-install-flow'
    | '/installFlow/complete-physical-install'
    | '/installFlow/create-asset-location'
    | '/installFlow/enter-name-plate-info'
    | '/installFlow/final-check'
    | '/installFlow/forgot-password'
    | '/installFlow/install-not-started'
    | '/installFlow/live-data'
    | '/installFlow/match-existing-asset'
    | '/installFlow/name-plate-photo'
    | '/installFlow/on-site-location'
    | '/installFlow/physical-install-steps'
    | '/installFlow/previous-tutorial'
    | '/installFlow/review-name-plate-info'
    | '/installFlow/review-name-plate-photo'
    | '/installFlow/select-organization'
    | '/installFlow/sensor-installed'
    | '/installFlow/sensor-scan'
    | '/'
    | '/sync'
    | '/organization/$organizationId'
    | '/all-organizations'
    | '/email-concierge'
    | '/issue-management'
    | '/opportunity-management'
    | '/sensor-kit-health'
    | '/sensor-kit-health-new'
    | '/validate-sensor-placement'
    | '/organization/no-organizations'
    | '/settings/notifications'
    | '/auth/verify-email/$key'
    | '/issues/shared/$token'
    | '/opportunities/shared/$token'
    | '/sync/$sensorKitSerialNumber/validate'
    | '/organization'
    | '/sync/$sensorKitSerialNumber'
    | '/engineering-charts'
    | '/metrics'
    | '/trends-beta'
    | '/achievements/$userId'
    | '/achievements/leaderboard'
    | '/organization/$organizationId/install-flow'
    | '/organization/$organizationId/issues'
    | '/organization/$organizationId/opportunities'
    | '/meters/$meterId'
    | '/organization/$organizationId/install'
    | '/meters'
    | '/organization/$organizationId/'
    | '/organization/$organizationId/locations/$locationId'
    | '/organization/$organizationId/issues/$opportunityId'
    | '/organization/$organizationId/opportunities/$opportunityId'
    | '/organization/$organizationId/invite-codes'
    | '/organization/$organizationId/issues/'
    | '/organization/$organizationId/locations'
    | '/organization/$organizationId/opportunities/'
    | '/organization/$organizationId/users'
    | '/organization/$organizationId/locations/$locationId/'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/charge-detection'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/health'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/on_period_analysis'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId'
    | '/organization/$organizationId/locations/$locationId/equipment/$equipmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/credential-reset'
    | '/credential-reset-request'
    | '/login'
    | '/roi-calculator'
    | '/signup'
    | '/coming_soon'
    | '/auth/callback'
    | '/installFlow/add-new-location'
    | '/installFlow/already-installed'
    | '/installFlow/aproved-install-flow'
    | '/installFlow/asset-location'
    | '/installFlow/asset-name'
    | '/installFlow/auth-install-flow'
    | '/installFlow/complete-physical-install'
    | '/installFlow/create-asset-location'
    | '/installFlow/enter-name-plate-info'
    | '/installFlow/final-check'
    | '/installFlow/forgot-password'
    | '/installFlow/install-not-started'
    | '/installFlow/live-data'
    | '/installFlow/match-existing-asset'
    | '/installFlow/name-plate-photo'
    | '/installFlow/on-site-location'
    | '/installFlow/physical-install-steps'
    | '/installFlow/previous-tutorial'
    | '/installFlow/review-name-plate-info'
    | '/installFlow/review-name-plate-photo'
    | '/installFlow/select-organization'
    | '/installFlow/sensor-installed'
    | '/installFlow/sensor-scan'
    | '/'
    | '/sync'
    | '/organization/$organizationId'
    | '/all-organizations'
    | '/email-concierge'
    | '/issue-management'
    | '/opportunity-management'
    | '/sensor-kit-health'
    | '/sensor-kit-health-new'
    | '/validate-sensor-placement'
    | '/organization/no-organizations'
    | '/settings/notifications'
    | '/auth/verify-email/$key'
    | '/issues/shared/$token'
    | '/opportunities/shared/$token'
    | '/sync/$sensorKitSerialNumber/validate'
    | '/organization'
    | '/sync/$sensorKitSerialNumber'
    | '/engineering-charts'
    | '/metrics'
    | '/trends-beta'
    | '/achievements/$userId'
    | '/achievements/leaderboard'
    | '/organization/$organizationId/install-flow'
    | '/meters/$meterId'
    | '/organization/$organizationId/install'
    | '/meters'
    | '/organization/$organizationId/issues/$opportunityId'
    | '/organization/$organizationId/opportunities/$opportunityId'
    | '/organization/$organizationId/invite-codes'
    | '/organization/$organizationId/issues'
    | '/organization/$organizationId/locations'
    | '/organization/$organizationId/opportunities'
    | '/organization/$organizationId/users'
    | '/organization/$organizationId/locations/$locationId'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/charge-detection'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/health'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId/on_period_analysis'
    | '/organization/$organizationId/locations/$locationId/assets/$assetId'
    | '/organization/$organizationId/locations/$locationId/equipment/$equipmentId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/credential-reset'
    | '/credential-reset-request'
    | '/login'
    | '/roi-calculator'
    | '/signup'
    | '/_authenticated/_staff'
    | '/_authenticated/coming_soon'
    | '/auth/callback'
    | '/installFlow/add-new-location'
    | '/installFlow/already-installed'
    | '/installFlow/aproved-install-flow'
    | '/installFlow/asset-location'
    | '/installFlow/asset-name'
    | '/installFlow/auth-install-flow'
    | '/installFlow/complete-physical-install'
    | '/installFlow/create-asset-location'
    | '/installFlow/enter-name-plate-info'
    | '/installFlow/final-check'
    | '/installFlow/forgot-password'
    | '/installFlow/install-not-started'
    | '/installFlow/live-data'
    | '/installFlow/match-existing-asset'
    | '/installFlow/name-plate-photo'
    | '/installFlow/on-site-location'
    | '/installFlow/physical-install-steps'
    | '/installFlow/previous-tutorial'
    | '/installFlow/review-name-plate-info'
    | '/installFlow/review-name-plate-photo'
    | '/installFlow/select-organization'
    | '/installFlow/sensor-installed'
    | '/installFlow/sensor-scan'
    | '/_authenticated/'
    | '/sync/'
    | '/_authenticated/_staff/_with_location_switcher'
    | '/_authenticated/organization/$organizationId'
    | '/_authenticated/_staff/all-organizations'
    | '/_authenticated/_staff/email-concierge'
    | '/_authenticated/_staff/issue-management'
    | '/_authenticated/_staff/opportunity-management'
    | '/_authenticated/_staff/sensor-kit-health'
    | '/_authenticated/_staff/sensor-kit-health-new'
    | '/_authenticated/_staff/validate-sensor-placement'
    | '/_authenticated/organization/no-organizations'
    | '/_authenticated/settings/notifications'
    | '/auth/verify-email/$key'
    | '/issues/shared/$token'
    | '/opportunities/shared/$token'
    | '/sync/$sensorKitSerialNumber/validate'
    | '/_authenticated/organization/'
    | '/sync/$sensorKitSerialNumber/'
    | '/_authenticated/organization/$organizationId/_installer'
    | '/_authenticated/organization/$organizationId/_non_installer'
    | '/_authenticated/_staff/_with_location_switcher/engineering-charts'
    | '/_authenticated/_staff/_with_location_switcher/metrics'
    | '/_authenticated/_staff/_with_location_switcher/trends-beta'
    | '/_authenticated/_staff/achievements/$userId'
    | '/_authenticated/_staff/achievements/leaderboard'
    | '/_authenticated/organization/$organizationId/install-flow'
    | '/_authenticated/organization/$organizationId/_non_installer/issues'
    | '/_authenticated/organization/$organizationId/_non_installer/opportunities'
    | '/_authenticated/_staff/_with_location_switcher/meters/$meterId'
    | '/_authenticated/organization/$organizationId/_installer/install'
    | '/_authenticated/_staff/_with_location_switcher/meters/'
    | '/_authenticated/organization/$organizationId/_non_installer/'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId'
    | '/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId'
    | '/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId'
    | '/_authenticated/organization/$organizationId/_non_installer/invite-codes/'
    | '/_authenticated/organization/$organizationId/_non_installer/issues/'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/'
    | '/_authenticated/organization/$organizationId/_non_installer/opportunities/'
    | '/_authenticated/organization/$organizationId/_non_installer/users/'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/charge-detection'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/'
    | '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  CredentialResetRoute: typeof CredentialResetRoute
  CredentialResetRequestRoute: typeof CredentialResetRequestRoute
  LoginRoute: typeof LoginRoute
  RoiCalculatorRoute: typeof RoiCalculatorRoute
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InstallFlowAddNewLocationRoute: typeof InstallFlowAddNewLocationRoute
  InstallFlowAlreadyInstalledRoute: typeof InstallFlowAlreadyInstalledRoute
  InstallFlowAprovedInstallFlowRoute: typeof InstallFlowAprovedInstallFlowRoute
  InstallFlowAssetLocationRoute: typeof InstallFlowAssetLocationRoute
  InstallFlowAssetNameRoute: typeof InstallFlowAssetNameRoute
  InstallFlowAuthInstallFlowRoute: typeof InstallFlowAuthInstallFlowRoute
  InstallFlowCompletePhysicalInstallRoute: typeof InstallFlowCompletePhysicalInstallRoute
  InstallFlowCreateAssetLocationRoute: typeof InstallFlowCreateAssetLocationRoute
  InstallFlowEnterNamePlateInfoRoute: typeof InstallFlowEnterNamePlateInfoRoute
  InstallFlowFinalCheckRoute: typeof InstallFlowFinalCheckRoute
  InstallFlowForgotPasswordRoute: typeof InstallFlowForgotPasswordRoute
  InstallFlowInstallNotStartedRoute: typeof InstallFlowInstallNotStartedRoute
  InstallFlowLiveDataRoute: typeof InstallFlowLiveDataRoute
  InstallFlowMatchExistingAssetRoute: typeof InstallFlowMatchExistingAssetRoute
  InstallFlowNamePlatePhotoRoute: typeof InstallFlowNamePlatePhotoRoute
  InstallFlowOnSiteLocationRoute: typeof InstallFlowOnSiteLocationRoute
  InstallFlowPhysicalInstallStepsRoute: typeof InstallFlowPhysicalInstallStepsRoute
  InstallFlowPreviousTutorialRoute: typeof InstallFlowPreviousTutorialRoute
  InstallFlowReviewNamePlateInfoRoute: typeof InstallFlowReviewNamePlateInfoRoute
  InstallFlowReviewNamePlatePhotoRoute: typeof InstallFlowReviewNamePlatePhotoRoute
  InstallFlowSelectOrganizationRoute: typeof InstallFlowSelectOrganizationRoute
  InstallFlowSensorInstalledRoute: typeof InstallFlowSensorInstalledRoute
  InstallFlowSensorScanRoute: typeof InstallFlowSensorScanRoute
  SyncIndexRoute: typeof SyncIndexRoute
  AuthVerifyEmailKeyRoute: typeof AuthVerifyEmailKeyRoute
  IssuesSharedTokenRoute: typeof IssuesSharedTokenRoute
  OpportunitiesSharedTokenRoute: typeof OpportunitiesSharedTokenRoute
  SyncSensorKitSerialNumberValidateRoute: typeof SyncSensorKitSerialNumberValidateRoute
  SyncSensorKitSerialNumberIndexRoute: typeof SyncSensorKitSerialNumberIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roi-calculator': {
      id: '/roi-calculator'
      path: '/roi-calculator'
      fullPath: '/roi-calculator'
      preLoaderRoute: typeof RoiCalculatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credential-reset-request': {
      id: '/credential-reset-request'
      path: '/credential-reset-request'
      fullPath: '/credential-reset-request'
      preLoaderRoute: typeof CredentialResetRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credential-reset': {
      id: '/credential-reset'
      path: '/credential-reset'
      fullPath: '/credential-reset'
      preLoaderRoute: typeof CredentialResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sync/': {
      id: '/sync/'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof SyncIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/installFlow/sensor-scan': {
      id: '/installFlow/sensor-scan'
      path: '/installFlow/sensor-scan'
      fullPath: '/installFlow/sensor-scan'
      preLoaderRoute: typeof InstallFlowSensorScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/sensor-installed': {
      id: '/installFlow/sensor-installed'
      path: '/installFlow/sensor-installed'
      fullPath: '/installFlow/sensor-installed'
      preLoaderRoute: typeof InstallFlowSensorInstalledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/select-organization': {
      id: '/installFlow/select-organization'
      path: '/installFlow/select-organization'
      fullPath: '/installFlow/select-organization'
      preLoaderRoute: typeof InstallFlowSelectOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/review-name-plate-photo': {
      id: '/installFlow/review-name-plate-photo'
      path: '/installFlow/review-name-plate-photo'
      fullPath: '/installFlow/review-name-plate-photo'
      preLoaderRoute: typeof InstallFlowReviewNamePlatePhotoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/review-name-plate-info': {
      id: '/installFlow/review-name-plate-info'
      path: '/installFlow/review-name-plate-info'
      fullPath: '/installFlow/review-name-plate-info'
      preLoaderRoute: typeof InstallFlowReviewNamePlateInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/previous-tutorial': {
      id: '/installFlow/previous-tutorial'
      path: '/installFlow/previous-tutorial'
      fullPath: '/installFlow/previous-tutorial'
      preLoaderRoute: typeof InstallFlowPreviousTutorialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/physical-install-steps': {
      id: '/installFlow/physical-install-steps'
      path: '/installFlow/physical-install-steps'
      fullPath: '/installFlow/physical-install-steps'
      preLoaderRoute: typeof InstallFlowPhysicalInstallStepsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/on-site-location': {
      id: '/installFlow/on-site-location'
      path: '/installFlow/on-site-location'
      fullPath: '/installFlow/on-site-location'
      preLoaderRoute: typeof InstallFlowOnSiteLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/name-plate-photo': {
      id: '/installFlow/name-plate-photo'
      path: '/installFlow/name-plate-photo'
      fullPath: '/installFlow/name-plate-photo'
      preLoaderRoute: typeof InstallFlowNamePlatePhotoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/match-existing-asset': {
      id: '/installFlow/match-existing-asset'
      path: '/installFlow/match-existing-asset'
      fullPath: '/installFlow/match-existing-asset'
      preLoaderRoute: typeof InstallFlowMatchExistingAssetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/live-data': {
      id: '/installFlow/live-data'
      path: '/installFlow/live-data'
      fullPath: '/installFlow/live-data'
      preLoaderRoute: typeof InstallFlowLiveDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/install-not-started': {
      id: '/installFlow/install-not-started'
      path: '/installFlow/install-not-started'
      fullPath: '/installFlow/install-not-started'
      preLoaderRoute: typeof InstallFlowInstallNotStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/forgot-password': {
      id: '/installFlow/forgot-password'
      path: '/installFlow/forgot-password'
      fullPath: '/installFlow/forgot-password'
      preLoaderRoute: typeof InstallFlowForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/final-check': {
      id: '/installFlow/final-check'
      path: '/installFlow/final-check'
      fullPath: '/installFlow/final-check'
      preLoaderRoute: typeof InstallFlowFinalCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/enter-name-plate-info': {
      id: '/installFlow/enter-name-plate-info'
      path: '/installFlow/enter-name-plate-info'
      fullPath: '/installFlow/enter-name-plate-info'
      preLoaderRoute: typeof InstallFlowEnterNamePlateInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/create-asset-location': {
      id: '/installFlow/create-asset-location'
      path: '/installFlow/create-asset-location'
      fullPath: '/installFlow/create-asset-location'
      preLoaderRoute: typeof InstallFlowCreateAssetLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/complete-physical-install': {
      id: '/installFlow/complete-physical-install'
      path: '/installFlow/complete-physical-install'
      fullPath: '/installFlow/complete-physical-install'
      preLoaderRoute: typeof InstallFlowCompletePhysicalInstallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/auth-install-flow': {
      id: '/installFlow/auth-install-flow'
      path: '/installFlow/auth-install-flow'
      fullPath: '/installFlow/auth-install-flow'
      preLoaderRoute: typeof InstallFlowAuthInstallFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/asset-name': {
      id: '/installFlow/asset-name'
      path: '/installFlow/asset-name'
      fullPath: '/installFlow/asset-name'
      preLoaderRoute: typeof InstallFlowAssetNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/asset-location': {
      id: '/installFlow/asset-location'
      path: '/installFlow/asset-location'
      fullPath: '/installFlow/asset-location'
      preLoaderRoute: typeof InstallFlowAssetLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/aproved-install-flow': {
      id: '/installFlow/aproved-install-flow'
      path: '/installFlow/aproved-install-flow'
      fullPath: '/installFlow/aproved-install-flow'
      preLoaderRoute: typeof InstallFlowAprovedInstallFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/already-installed': {
      id: '/installFlow/already-installed'
      path: '/installFlow/already-installed'
      fullPath: '/installFlow/already-installed'
      preLoaderRoute: typeof InstallFlowAlreadyInstalledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/installFlow/add-new-location': {
      id: '/installFlow/add-new-location'
      path: '/installFlow/add-new-location'
      fullPath: '/installFlow/add-new-location'
      preLoaderRoute: typeof InstallFlowAddNewLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/coming_soon': {
      id: '/_authenticated/coming_soon'
      path: '/coming_soon'
      fullPath: '/coming_soon'
      preLoaderRoute: typeof AuthenticatedComing_soonRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_staff': {
      id: '/_authenticated/_staff'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedStaffRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/sync/$sensorKitSerialNumber/': {
      id: '/sync/$sensorKitSerialNumber/'
      path: '/sync/$sensorKitSerialNumber'
      fullPath: '/sync/$sensorKitSerialNumber'
      preLoaderRoute: typeof SyncSensorKitSerialNumberIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/organization/': {
      id: '/_authenticated/organization/'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthenticatedOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/sync/$sensorKitSerialNumber/validate': {
      id: '/sync/$sensorKitSerialNumber/validate'
      path: '/sync/$sensorKitSerialNumber/validate'
      fullPath: '/sync/$sensorKitSerialNumber/validate'
      preLoaderRoute: typeof SyncSensorKitSerialNumberValidateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunities/shared/$token': {
      id: '/opportunities/shared/$token'
      path: '/opportunities/shared/$token'
      fullPath: '/opportunities/shared/$token'
      preLoaderRoute: typeof OpportunitiesSharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/issues/shared/$token': {
      id: '/issues/shared/$token'
      path: '/issues/shared/$token'
      fullPath: '/issues/shared/$token'
      preLoaderRoute: typeof IssuesSharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email/$key': {
      id: '/auth/verify-email/$key'
      path: '/auth/verify-email/$key'
      fullPath: '/auth/verify-email/$key'
      preLoaderRoute: typeof AuthVerifyEmailKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organization/no-organizations': {
      id: '/_authenticated/organization/no-organizations'
      path: '/organization/no-organizations'
      fullPath: '/organization/no-organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationNoOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_staff/validate-sensor-placement': {
      id: '/_authenticated/_staff/validate-sensor-placement'
      path: '/validate-sensor-placement'
      fullPath: '/validate-sensor-placement'
      preLoaderRoute: typeof AuthenticatedStaffValidateSensorPlacementRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/sensor-kit-health-new': {
      id: '/_authenticated/_staff/sensor-kit-health-new'
      path: '/sensor-kit-health-new'
      fullPath: '/sensor-kit-health-new'
      preLoaderRoute: typeof AuthenticatedStaffSensorKitHealthNewRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/sensor-kit-health': {
      id: '/_authenticated/_staff/sensor-kit-health'
      path: '/sensor-kit-health'
      fullPath: '/sensor-kit-health'
      preLoaderRoute: typeof AuthenticatedStaffSensorKitHealthRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/opportunity-management': {
      id: '/_authenticated/_staff/opportunity-management'
      path: '/opportunity-management'
      fullPath: '/opportunity-management'
      preLoaderRoute: typeof AuthenticatedStaffOpportunityManagementRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/issue-management': {
      id: '/_authenticated/_staff/issue-management'
      path: '/issue-management'
      fullPath: '/issue-management'
      preLoaderRoute: typeof AuthenticatedStaffIssueManagementRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/email-concierge': {
      id: '/_authenticated/_staff/email-concierge'
      path: '/email-concierge'
      fullPath: '/email-concierge'
      preLoaderRoute: typeof AuthenticatedStaffEmailConciergeRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/all-organizations': {
      id: '/_authenticated/_staff/all-organizations'
      path: '/all-organizations'
      fullPath: '/all-organizations'
      preLoaderRoute: typeof AuthenticatedStaffAllOrganizationsRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/organization/$organizationId': {
      id: '/_authenticated/organization/$organizationId'
      path: '/organization/$organizationId'
      fullPath: '/organization/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher': {
      id: '/_authenticated/_staff/_with_location_switcher'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherRouteRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/organization/$organizationId/install-flow': {
      id: '/_authenticated/organization/$organizationId/install-flow'
      path: '/install-flow'
      fullPath: '/organization/$organizationId/install-flow'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdInstallFlowRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdRouteRoute
    }
    '/_authenticated/_staff/achievements/leaderboard': {
      id: '/_authenticated/_staff/achievements/leaderboard'
      path: '/achievements/leaderboard'
      fullPath: '/achievements/leaderboard'
      preLoaderRoute: typeof AuthenticatedStaffAchievementsLeaderboardRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/achievements/$userId': {
      id: '/_authenticated/_staff/achievements/$userId'
      path: '/achievements/$userId'
      fullPath: '/achievements/$userId'
      preLoaderRoute: typeof AuthenticatedStaffAchievementsUserIdRouteImport
      parentRoute: typeof AuthenticatedStaffRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher/trends-beta': {
      id: '/_authenticated/_staff/_with_location_switcher/trends-beta'
      path: '/trends-beta'
      fullPath: '/trends-beta'
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherTrendsBetaRouteImport
      parentRoute: typeof AuthenticatedStaffWith_location_switcherRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher/metrics': {
      id: '/_authenticated/_staff/_with_location_switcher/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherMetricsRouteImport
      parentRoute: typeof AuthenticatedStaffWith_location_switcherRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher/engineering-charts': {
      id: '/_authenticated/_staff/_with_location_switcher/engineering-charts'
      path: '/engineering-charts'
      fullPath: '/engineering-charts'
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherEngineeringChartsRouteImport
      parentRoute: typeof AuthenticatedStaffWith_location_switcherRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer': {
      id: '/_authenticated/organization/$organizationId/_non_installer'
      path: ''
      fullPath: '/organization/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_installer': {
      id: '/_authenticated/organization/$organizationId/_installer'
      path: ''
      fullPath: '/organization/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdInstallerRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/'
      path: '/'
      fullPath: '/organization/$organizationId/'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher/meters/': {
      id: '/_authenticated/_staff/_with_location_switcher/meters/'
      path: '/meters'
      fullPath: '/meters'
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherMetersIndexRouteImport
      parentRoute: typeof AuthenticatedStaffWith_location_switcherRouteRoute
    }
    '/_authenticated/organization/$organizationId/_installer/install': {
      id: '/_authenticated/organization/$organizationId/_installer/install'
      path: '/install'
      fullPath: '/organization/$organizationId/install'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdInstallerInstallRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdInstallerRouteRoute
    }
    '/_authenticated/_staff/_with_location_switcher/meters/$meterId': {
      id: '/_authenticated/_staff/_with_location_switcher/meters/$meterId'
      path: '/meters/$meterId'
      fullPath: '/meters/$meterId'
      preLoaderRoute: typeof AuthenticatedStaffWith_location_switcherMetersMeterIdRouteImport
      parentRoute: typeof AuthenticatedStaffWith_location_switcherRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/opportunities': {
      id: '/_authenticated/organization/$organizationId/_non_installer/opportunities'
      path: '/opportunities'
      fullPath: '/organization/$organizationId/opportunities'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/issues': {
      id: '/_authenticated/organization/$organizationId/_non_installer/issues'
      path: '/issues'
      fullPath: '/organization/$organizationId/issues'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/users/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/users/'
      path: '/users'
      fullPath: '/organization/$organizationId/users'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/opportunities/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/opportunities/'
      path: '/'
      fullPath: '/organization/$organizationId/opportunities/'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/'
      path: '/locations'
      fullPath: '/organization/$organizationId/locations'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/issues/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/issues/'
      path: '/'
      fullPath: '/organization/$organizationId/issues/'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/invite-codes/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/invite-codes/'
      path: '/invite-codes'
      fullPath: '/organization/$organizationId/invite-codes'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId': {
      id: '/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId'
      path: '/$opportunityId'
      fullPath: '/organization/$organizationId/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId': {
      id: '/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId'
      path: '/$opportunityId'
      fullPath: '/organization/$organizationId/issues/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId'
      path: '/locations/$locationId'
      fullPath: '/organization/$organizationId/locations/$locationId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/'
      path: '/'
      fullPath: '/organization/$organizationId/locations/$locationId/'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/equipment/$equipmentId/'
      path: '/equipment/$equipmentId'
      fullPath: '/organization/$organizationId/locations/$locationId/equipment/$equipmentId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/'
      path: '/assets/$assetId'
      fullPath: '/organization/$organizationId/locations/$locationId/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis'
      path: '/assets/$assetId/on_period_analysis'
      fullPath: '/organization/$organizationId/locations/$locationId/assets/$assetId/on_period_analysis'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/health'
      path: '/assets/$assetId/health'
      fullPath: '/organization/$organizationId/locations/$locationId/assets/$assetId/health'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
    '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/charge-detection': {
      id: '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/charge-detection'
      path: '/assets/$assetId/charge-detection'
      fullPath: '/organization/$organizationId/locations/$locationId/assets/$assetId/charge-detection'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute
    }
  }
}

interface AuthenticatedStaffWith_location_switcherRouteRouteChildren {
  AuthenticatedStaffWith_location_switcherEngineeringChartsRoute: typeof AuthenticatedStaffWith_location_switcherEngineeringChartsRoute
  AuthenticatedStaffWith_location_switcherMetricsRoute: typeof AuthenticatedStaffWith_location_switcherMetricsRoute
  AuthenticatedStaffWith_location_switcherTrendsBetaRoute: typeof AuthenticatedStaffWith_location_switcherTrendsBetaRoute
  AuthenticatedStaffWith_location_switcherMetersMeterIdRoute: typeof AuthenticatedStaffWith_location_switcherMetersMeterIdRoute
  AuthenticatedStaffWith_location_switcherMetersIndexRoute: typeof AuthenticatedStaffWith_location_switcherMetersIndexRoute
}

const AuthenticatedStaffWith_location_switcherRouteRouteChildren: AuthenticatedStaffWith_location_switcherRouteRouteChildren =
  {
    AuthenticatedStaffWith_location_switcherEngineeringChartsRoute:
      AuthenticatedStaffWith_location_switcherEngineeringChartsRoute,
    AuthenticatedStaffWith_location_switcherMetricsRoute:
      AuthenticatedStaffWith_location_switcherMetricsRoute,
    AuthenticatedStaffWith_location_switcherTrendsBetaRoute:
      AuthenticatedStaffWith_location_switcherTrendsBetaRoute,
    AuthenticatedStaffWith_location_switcherMetersMeterIdRoute:
      AuthenticatedStaffWith_location_switcherMetersMeterIdRoute,
    AuthenticatedStaffWith_location_switcherMetersIndexRoute:
      AuthenticatedStaffWith_location_switcherMetersIndexRoute,
  }

const AuthenticatedStaffWith_location_switcherRouteRouteWithChildren =
  AuthenticatedStaffWith_location_switcherRouteRoute._addFileChildren(
    AuthenticatedStaffWith_location_switcherRouteRouteChildren,
  )

interface AuthenticatedStaffRouteRouteChildren {
  AuthenticatedStaffWith_location_switcherRouteRoute: typeof AuthenticatedStaffWith_location_switcherRouteRouteWithChildren
  AuthenticatedStaffAllOrganizationsRoute: typeof AuthenticatedStaffAllOrganizationsRoute
  AuthenticatedStaffEmailConciergeRoute: typeof AuthenticatedStaffEmailConciergeRoute
  AuthenticatedStaffIssueManagementRoute: typeof AuthenticatedStaffIssueManagementRoute
  AuthenticatedStaffOpportunityManagementRoute: typeof AuthenticatedStaffOpportunityManagementRoute
  AuthenticatedStaffSensorKitHealthRoute: typeof AuthenticatedStaffSensorKitHealthRoute
  AuthenticatedStaffSensorKitHealthNewRoute: typeof AuthenticatedStaffSensorKitHealthNewRoute
  AuthenticatedStaffValidateSensorPlacementRoute: typeof AuthenticatedStaffValidateSensorPlacementRoute
  AuthenticatedStaffAchievementsUserIdRoute: typeof AuthenticatedStaffAchievementsUserIdRoute
  AuthenticatedStaffAchievementsLeaderboardRoute: typeof AuthenticatedStaffAchievementsLeaderboardRoute
}

const AuthenticatedStaffRouteRouteChildren: AuthenticatedStaffRouteRouteChildren =
  {
    AuthenticatedStaffWith_location_switcherRouteRoute:
      AuthenticatedStaffWith_location_switcherRouteRouteWithChildren,
    AuthenticatedStaffAllOrganizationsRoute:
      AuthenticatedStaffAllOrganizationsRoute,
    AuthenticatedStaffEmailConciergeRoute:
      AuthenticatedStaffEmailConciergeRoute,
    AuthenticatedStaffIssueManagementRoute:
      AuthenticatedStaffIssueManagementRoute,
    AuthenticatedStaffOpportunityManagementRoute:
      AuthenticatedStaffOpportunityManagementRoute,
    AuthenticatedStaffSensorKitHealthRoute:
      AuthenticatedStaffSensorKitHealthRoute,
    AuthenticatedStaffSensorKitHealthNewRoute:
      AuthenticatedStaffSensorKitHealthNewRoute,
    AuthenticatedStaffValidateSensorPlacementRoute:
      AuthenticatedStaffValidateSensorPlacementRoute,
    AuthenticatedStaffAchievementsUserIdRoute:
      AuthenticatedStaffAchievementsUserIdRoute,
    AuthenticatedStaffAchievementsLeaderboardRoute:
      AuthenticatedStaffAchievementsLeaderboardRoute,
  }

const AuthenticatedStaffRouteRouteWithChildren =
  AuthenticatedStaffRouteRoute._addFileChildren(
    AuthenticatedStaffRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdInstallerRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdInstallerInstallRoute: typeof AuthenticatedOrganizationOrganizationIdInstallerInstallRoute
}

const AuthenticatedOrganizationOrganizationIdInstallerRouteRouteChildren: AuthenticatedOrganizationOrganizationIdInstallerRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdInstallerInstallRoute:
      AuthenticatedOrganizationOrganizationIdInstallerInstallRoute,
  }

const AuthenticatedOrganizationOrganizationIdInstallerRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdInstallerRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdInstallerRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute
}

const AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteChildren: AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerIssuesOpportunityIdRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerIssuesIndexRoute,
  }

const AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute
}

const AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteChildren: AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesOpportunityIdRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesIndexRoute,
  }

const AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute
}

const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteChildren: AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdIndexRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdChargeDetectionRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdHealthRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdOn_period_analysisRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdAssetsAssetIdIndexRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdEquipmentEquipmentIdIndexRoute,
  }

const AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute
  AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute
  AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute
}

const AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteChildren: AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerIssuesRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerOpportunitiesRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerIndexRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsLocationIdRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerInviteCodesIndexRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerLocationsIndexRoute,
    AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerUsersIndexRoute,
  }

const AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationIdRouteRouteChildren {
  AuthenticatedOrganizationOrganizationIdInstallerRouteRoute: typeof AuthenticatedOrganizationOrganizationIdInstallerRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute: typeof AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationIdInstallFlowRoute: typeof AuthenticatedOrganizationOrganizationIdInstallFlowRoute
}

const AuthenticatedOrganizationOrganizationIdRouteRouteChildren: AuthenticatedOrganizationOrganizationIdRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationIdInstallerRouteRoute:
      AuthenticatedOrganizationOrganizationIdInstallerRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationIdNon_installerRouteRoute:
      AuthenticatedOrganizationOrganizationIdNon_installerRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationIdInstallFlowRoute:
      AuthenticatedOrganizationOrganizationIdInstallFlowRoute,
  }

const AuthenticatedOrganizationOrganizationIdRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationIdRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedStaffRouteRoute: typeof AuthenticatedStaffRouteRouteWithChildren
  AuthenticatedComing_soonRoute: typeof AuthenticatedComing_soonRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrganizationOrganizationIdRouteRoute: typeof AuthenticatedOrganizationOrganizationIdRouteRouteWithChildren
  AuthenticatedOrganizationNoOrganizationsRoute: typeof AuthenticatedOrganizationNoOrganizationsRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedOrganizationIndexRoute: typeof AuthenticatedOrganizationIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedStaffRouteRoute: AuthenticatedStaffRouteRouteWithChildren,
  AuthenticatedComing_soonRoute: AuthenticatedComing_soonRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrganizationOrganizationIdRouteRoute:
    AuthenticatedOrganizationOrganizationIdRouteRouteWithChildren,
  AuthenticatedOrganizationNoOrganizationsRoute:
    AuthenticatedOrganizationNoOrganizationsRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedOrganizationIndexRoute: AuthenticatedOrganizationIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  CredentialResetRoute: CredentialResetRoute,
  CredentialResetRequestRoute: CredentialResetRequestRoute,
  LoginRoute: LoginRoute,
  RoiCalculatorRoute: RoiCalculatorRoute,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InstallFlowAddNewLocationRoute: InstallFlowAddNewLocationRoute,
  InstallFlowAlreadyInstalledRoute: InstallFlowAlreadyInstalledRoute,
  InstallFlowAprovedInstallFlowRoute: InstallFlowAprovedInstallFlowRoute,
  InstallFlowAssetLocationRoute: InstallFlowAssetLocationRoute,
  InstallFlowAssetNameRoute: InstallFlowAssetNameRoute,
  InstallFlowAuthInstallFlowRoute: InstallFlowAuthInstallFlowRoute,
  InstallFlowCompletePhysicalInstallRoute:
    InstallFlowCompletePhysicalInstallRoute,
  InstallFlowCreateAssetLocationRoute: InstallFlowCreateAssetLocationRoute,
  InstallFlowEnterNamePlateInfoRoute: InstallFlowEnterNamePlateInfoRoute,
  InstallFlowFinalCheckRoute: InstallFlowFinalCheckRoute,
  InstallFlowForgotPasswordRoute: InstallFlowForgotPasswordRoute,
  InstallFlowInstallNotStartedRoute: InstallFlowInstallNotStartedRoute,
  InstallFlowLiveDataRoute: InstallFlowLiveDataRoute,
  InstallFlowMatchExistingAssetRoute: InstallFlowMatchExistingAssetRoute,
  InstallFlowNamePlatePhotoRoute: InstallFlowNamePlatePhotoRoute,
  InstallFlowOnSiteLocationRoute: InstallFlowOnSiteLocationRoute,
  InstallFlowPhysicalInstallStepsRoute: InstallFlowPhysicalInstallStepsRoute,
  InstallFlowPreviousTutorialRoute: InstallFlowPreviousTutorialRoute,
  InstallFlowReviewNamePlateInfoRoute: InstallFlowReviewNamePlateInfoRoute,
  InstallFlowReviewNamePlatePhotoRoute: InstallFlowReviewNamePlatePhotoRoute,
  InstallFlowSelectOrganizationRoute: InstallFlowSelectOrganizationRoute,
  InstallFlowSensorInstalledRoute: InstallFlowSensorInstalledRoute,
  InstallFlowSensorScanRoute: InstallFlowSensorScanRoute,
  SyncIndexRoute: SyncIndexRoute,
  AuthVerifyEmailKeyRoute: AuthVerifyEmailKeyRoute,
  IssuesSharedTokenRoute: IssuesSharedTokenRoute,
  OpportunitiesSharedTokenRoute: OpportunitiesSharedTokenRoute,
  SyncSensorKitSerialNumberValidateRoute:
    SyncSensorKitSerialNumberValidateRoute,
  SyncSensorKitSerialNumberIndexRoute: SyncSensorKitSerialNumberIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
